import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { ApplicationStartupData } from "./StartupData";

export class GetStartupDataResponse extends ApiGenericResponse {
    applicationStartupData: ApplicationStartupData;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data.Payload) {
            this.applicationStartupData = ApplicationStartupData.parse(response.data.Payload);
        }
    }
}
